import React, { LegacyRef } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentPeople = React.forwardRef<
  SVGElement,
  { fillColor?: string } & SvgProps
>(({ fillColor = '#212121', ...props }, ref) => (
  <Svg
    width={24}
    height={24}
    fill='none'
    viewBox='0 0 24 24'
    {...props}
    ref={ref as LegacyRef<Svg>}
  >
    <Path
      d='M4 13.999L13 14a2 2 0 011.995 1.85L15 16v1.5C14.999 21 11.284 22 8.5 22c-2.722 0-6.335-.956-6.495-4.27L2 17.5v-1.501c0-1.054.816-1.918 1.85-1.995L4 14zM15.22 14H20a2 2 0 011.994 1.85L22 16v1c-.001 3.062-2.858 4-5 4a7.16 7.16 0 01-2.14-.322c.336-.386.607-.827.802-1.327A6.19 6.19 0 0017 19.5l.267-.006c.985-.043 3.086-.363 3.226-2.289L20.5 17v-1a.501.501 0 00-.41-.492L20 15.5h-4.051a2.957 2.957 0 00-.595-1.34L15.22 14H20h-4.78zM4 15.499l-.1.01a.51.51 0 00-.254.136.506.506 0 00-.136.253l-.01.101V17.5c0 1.009.45 1.722 1.417 2.242.826.445 2.003.714 3.266.753l.317.005.317-.005c1.263-.039 2.439-.308 3.266-.753.906-.488 1.359-1.145 1.412-2.057l.005-.186V16a.501.501 0 00-.41-.492L13 15.5l-9-.001zM8.5 3a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm9 2a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm-9-.5c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm9 2c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z'
      fill={fillColor}
    />
  </Svg>
))

FluentPeople.displayName = 'FluentPeople'

export default FluentPeople
